import { CheckOutlineIcon } from '@ikyucom/design-system-icons-react'
import { StackableSlideUpModal } from '~/components/modal/StackableSlideUpModal'
import { useCloseNewReserveSuccess } from '~/features/reservationInput/shared/hooks'
import { useReserveOverlay } from '~/navigation'
import { css, sva } from '~/styled-system/css'
import {
  CancelPolicy,
  ConfirmButton,
  Conversion,
  Detail,
  EmailSendNotification,
  RequestReservation,
  SuccessMessage,
} from '../shared/reservationSuccess'
import { StepTitle } from './StepTitle'

const styles = sva({
  slots: ['container', 'icon'],
  base: {
    container: {
      textAlign: 'center',
      spaceY: '1',
    },
    icon: {
      display: 'inline-block',
      borderRadius: 'full',
      color: 'white',
      p: '3',
      bgColor: 'background',
    },
  },
})

export function ReservationSuccessModal() {
  const [context, willBeUnmounted] = useReserveOverlay('NEW_RESERVE_SUCCESS')
  const close = useCloseNewReserveSuccess()
  if (context === undefined) {
    return null
  }
  const classes = styles()
  return (
    <StackableSlideUpModal
      type="modal"
      wide="wide"
      animationType="fadeIn"
      willBeUnmounted={willBeUnmounted}
      onClose={close}
      title={<StepTitle mode="embed" state="RESERVE_SUCCESS" />}
      className={css({ px: '10', pt: '6', pb: '4', spaceY: '4' })}
    >
      <div className={classes.container}>
        <div className={classes.icon}>
          <CheckOutlineIcon className={css({ color: 'tertiary' })} width={48} height={48} />
        </div>
        <SuccessMessage />
      </div>
      <div
        className={css({
          p: '5',
          borderRadius: 'md',
          bgColor: 'gray.100',
          spaceY: '4',
          textAlign: 'center',
        })}
      >
        <Detail />
        <RequestReservation />
        <ConfirmButton />
        <EmailSendNotification />
      </div>
      <CancelPolicy />
      <Conversion />
    </StackableSlideUpModal>
  )
}
